"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notification = void 0;
const endpoint_1 = require("../endpoint/endpoint");
const utils_1 = require("../utils");
const parse_sort_object_1 = require("../utils/parse-sort-object");
const base = '/notification';
const subscribe = (payload, options) => {
    const url = (0, utils_1.urlFactory)(base, '/subscribe');
    return new endpoint_1.Endpoint({
        url,
        init: { method: 'POST' },
        payload,
        options
    });
};
const publicKey = (options) => {
    const url = (0, utils_1.urlFactory)(base, '/public-key');
    return new endpoint_1.Endpoint({
        url,
        init: { method: 'GET' },
        options
    });
};
const filter = (_a, options) => {
    var { page, size, sort } = _a, payload = __rest(_a, ["page", "size", "sort"]);
    const url = (0, utils_1.urlFactory)(base, `/filter`, {
        page,
        size,
        sort: (0, parse_sort_object_1.parseSortObject)(sort)
    });
    return new endpoint_1.Endpoint({
        url,
        init: { method: 'POST' },
        payload,
        options
    });
};
const update = (_a, options) => {
    var { notificationId } = _a, payload = __rest(_a, ["notificationId"]);
    const url = (0, utils_1.urlFactory)(base, `/${notificationId}`);
    return new endpoint_1.Endpoint({
        url,
        init: { method: 'PUT' },
        payload,
        options
    });
};
exports.notification = { subscribe, publicKey, filter, update };
